import {
  Avatar,
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import {
  Description as DescriptionIcon,
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Place as PlaceIcon,
} from "@mui/icons-material";
import image_of_me from "../../../media/me.jpg";

export default function ProfileCard() {
  return (
    <Paper
      className="section-card profile-card"
      sx={{ flexDirection: "column" }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Avatar
          src={image_of_me}
          alt="Mark Reading"
          sx={{ width: 200, height: 200, mb: 2, border: "3px solid #81cbe9" }}
        />
        <Typography className="name-header" sx={{ fontSize: "1.75rem", mb: 1 }}>
          Mark Reading
        </Typography>
        <Typography
          color="text.secondary"
          sx={{ textAlign: "center", mb: 2, lineHeight: 1.5 }}
        >
          ASIC Engineer @ Cisco
        </Typography>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 2 }}>
          <PlaceIcon color="primary" fontSize="small" />
          <Typography variant="body2">San Jose, CA</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          <IconButton
            color="primary"
            href="https://www.linkedin.com/in/markreading2/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            color="primary"
            href="https://github.com/markreading"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <GitHubIcon />
          </IconButton>
          {/* <IconButton
            color="primary"
            href="/resume-19.pdf"
            target="_blank"
            rel="noreferrer"
            aria-label="Resume"
          >
            <DescriptionIcon />
          </IconButton> */}
        </Stack>
      </Box>
    </Paper>
  );
}
